export const WORKSPACE_DOCUMENT_READ_ONLY_MESSAGE =
  'This document belongs to a workspace, so it is read-only here. Open the workspace to make changes.';

type WorkspaceDocumentRef = {
  id?: string | null;
  kind?: string | null;
  projectId?: string | null;
};

/** Documents that belong to a workspace are changed only from the workspace. */
export function isWorkspaceDocument(doc: WorkspaceDocumentRef | null | undefined): boolean {
  return String(doc?.projectId || '').trim() !== '';
}

export function workspaceDocumentPath(doc: WorkspaceDocumentRef | null | undefined): string | null {
  const projectId = String(doc?.projectId || '').trim();
  if (!projectId) return null;
  const base = `/projects/${encodeURIComponent(projectId)}/workspace`;
  const id = String(doc?.id || '').trim();
  if (doc?.kind === 'Invoice') {
    return id ? `${base}/invoices?doc=${encodeURIComponent(id)}` : `${base}/invoices`;
  }
  return `${base}/quotes`;
}
